import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION_AWS,
  GET_INTEGRATION_AWS_BY_INTEGRATION
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegrationAWS",
    method: "post",
    url: CRUD_INTEGRATION_AWS,
    stateKey: "message",
  },
  {
    name: "getIntegrationAWSByIntegration",
    method: "get",
    url: GET_INTEGRATION_AWS_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "updateIntegrationAWS",
    method: "put",
    url: CRUD_INTEGRATION_AWS,
    stateKey: "message",
  },
  {
    name: "updateIntegrationAwsStatus",
    method: "patch",
    url: `${CRUD_INTEGRATION_AWS}/update_status`,
    stateKey: "message",
  },
  {
    name: "deleteIntegrationAWS",
    method: "delete",
    url: CRUD_INTEGRATION_AWS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "integrationAWS",
  apiConfig,
  customReducers,
);
const integrationAWSSlice = slice;
// Export the slice's reducer
export default integrationAWSSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addIntegrationAWS,
  getIntegrationAWSByIntegration,
  updateIntegrationAWS,
  deleteIntegrationAWS,
  updateIntegrationAwsStatus,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect, } =
  actions;
